import type { StorageLocationsEntity } from '~/domain/Insurance/storageLocationsEntity';
import type { StorageLocationQuestionResponseDTO } from '~/dto/Insurance/storageLocationQuestionDTO';
import { storageLocationsResponseMapper } from '~/mappers/Insurance/storageLocationsResponseMapper';
import apiAssegurouAuto from '~/services/apiAssegurouAuto';

export async function getStorageLocationsUseCase(): Promise<StorageLocationsEntity> {
  try {
    const response =
      await apiAssegurouAuto.get<StorageLocationQuestionResponseDTO>(
        `/auto/perguntas/localGuarda`
      );

    return storageLocationsResponseMapper(response.data);
  } catch (error) {
    return { success: false, storageLocations: {} };
  }
}
